import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMGoogleAccountResource from 'resources/SMGoogleAccountResource';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMOSettingEditCalendarFragmentView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      owner: this.props.owner,
      ownerRooms: [],
      googleAccount: null,
      display: SMConst.Display.Visible,
      isCurrent : this.props.isCurrent,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
    this.requestGoogleAccountResource();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : nextProps.isCurrent,
      owner : nextProps.owner,
    });
  }

  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  requestGoogleAccountResource(){
    if (this.state.display == SMConst.Display.Loading) return;
    this.setState({display: SMConst.Display.Loading});
    let queries = {};

    $(this.refs.form).startLoading();
    SMGoogleAccountResource.getGoogleAccount({owner_id:this.state.owner.username}, (data, error, xhr)=>{
      this.setState({
        googleAccount: data,
      });
    });
    SMOwnerResource.getRooms(this.state.owner.id, {per_page: 250}, (data, error, xhr) => {
      this.setState({
        ownerRooms: data,
        display: SMConst.Display.Visible
      });
      $(this.refs.fragment).stopLoading();
    });
  }

  handleAddAssociation (direction, e) {
    e.preventDefault();
    this.setState((previousState, currentProps) => {
      let account = previousState.googleAccount;
      account.enable_calendars.push({account_service_method: direction});
    });
  }
  handleRemoveAssociation(direction, item, index, e) {
    e.preventDefault();

    this.setState((previousState, currentProps) => {
      let account = previousState.googleAccount;
      account.enable_calendars.filter((calendar) => { return calendar.account_service_method == direction; })[index]._destroy = true;
      return { googleAccount: account };
    });
  }

  sizeToFit() {
    let $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);

    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }

  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  saveFormDidSubmit(e){
    e.preventDefault();
    this.trackPageEvent('od save calendar_setting');
    $(this.refs.form).startLoading();
    this.setState({display: SMConst.Display.Loading});

    let formData = new FormData(this.refs.form);
    SMGoogleAccountResource.updateGoogleAccount(this.props.owner.username, formData, {}, (data, error, xhr) => {
      this.setState({
        googleAccount: data,
        display: SMConst.Display.Visible
      });

      // 「保存完了しました」を出すためのworkaround hack。別に再読み込みする必要はない
      location.href = Routes.updated_owner_dashboard_settings_calendar_path(this.props.owner.username, {state: this.props.owner.username});
    });
  }

  createAssociationButtonDidClick(e){
    e.preventDefault();
    location.href = Routes.oauth2request_owner_dashboard_settings_calendar_path(this.props.owner.username, {state: this.props.owner.username});
  }

  removeAssociationButtonDidClick(e){
    e.preventDefault();
    if(!window.confirm(I18n.t("dashboard.notice_000003"))) return;

    $(this.refs.form).startLoading();
    this.setState({display: SMConst.Display.Loading});
    SMGoogleAccountResource.deleteGoogleAccount(this.state.owner.username, (data, error, xhr)=>{
      // 「保存完了しました」を出すためのworkaround hack。別に再読み込みする必要はない
      location.href = Routes.updated_owner_dashboard_settings_calendar_path(this.props.owner.username, {state: this.props.owner.username});
    });
  }

  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>Googleカレンダー
          <span className="dashboard-title__supplement ml15">
            スペースの予約カレンダーとGoogleカレンダーのインポート/エクスポート設定を行うことができます。
          </span>
        </h2>

        <form ref="form">
          <div className="form-box">
            {this.renderAssociationButton(this.state.googleAccount)}
          </div>

          {this.renderAssociations(this.state.googleAccount, this.state.ownerRooms)}

          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input type="submit" onClick={this.saveFormDidSubmit.bind(this)} className="button-green maincol-buttonarea__button" value="保存" />
          </div>
        </form>
      </div>
    );
  }

  renderAssociationButton(account) {
    let callback = null,
        label = '',
        description = '';

    if (account != null) {
      if (Object.keys(account).length < 1) {
        label = 'Googleカレンダーと連携',
        description = 'Googleカレンダーからインポート/エクスポートを行う場合は連携を承諾してください。',
        callback = this.createAssociationButtonDidClick.bind(this);
      } else {
        label = 'Googleカレンダーと連携解除',
        description = 'Googleカレンダーと連携済みです。連携を解除する場合は左のボタンを押してください。',
        callback = this.removeAssociationButtonDidClick.bind(this);
      }
    }

    return(
      <p>
        <input type="submit" onClick={callback} className="button button-blue pt10 pb10 w220 mr10" value={label} />
        <span>{description}</span>
      </p>
    );
  }

  renderAssociations(account, rooms){
    if (account == null || account.available_calendars == null || rooms == null) return;

    let import_available_calendars = account.available_calendars.filter((calendar) => { return [SMConst.AuthorityForGoogleCalendar.Read, SMConst.AuthorityForGoogleCalendar.ReadAndWrite].indexOf(calendar.access_role) >= 0; });
    let import_enable_calendars = account.enable_calendars.filter((calendar) => { return calendar.account_service_method == SMConst.GoogleCalendarDirection.Import; });
    let export_available_calendars = account.available_calendars.filter((calendar) => { return calendar.access_role == SMConst.AuthorityForGoogleCalendar.ReadAndWrite; });
    let export_enable_calendars = account.enable_calendars.filter((calendar) => { return calendar.account_service_method == SMConst.GoogleCalendarDirection.Export; });

    return(
      <div>
        {this.renderAssociationsList(SMConst.GoogleCalendarDirection.Import, import_available_calendars, import_enable_calendars, rooms)}
        {this.renderAssociationsList(SMConst.GoogleCalendarDirection.Export, export_available_calendars, export_enable_calendars, rooms)}
      </div>
    );
  }

  renderAssociationsList  (direction, available_calendars, enable_calendars, rooms) {
    let text_list = {};
    if (direction == SMConst.GoogleCalendarDirection.Import) {
      text_list = {
        direction: 'インポート',
        from: 'Googleカレンダー',
        to: 'スペースを管理する'
      };
    } else if (direction == SMConst.GoogleCalendarDirection.Export) {
      text_list = {
        direction: 'エクスポート',
        from: 'スペースを管理する',
        to: 'Googleカレンダー'
      };
    }

    return(
      <div>
        <h3 className="dashboard-title2 mb20">{text_list.direction}</h3>
        <div className="form-box">
          {((hasItems)=>{
            if (!hasItems) return;
            return (
              <div className="clearfix mb5">
                <div className="w320 fl">
                  <p className="dashboard-title__supplement">{text_list.from}</p>
                </div>
                <div className="w35 fl">&nbsp;</div>
                <div className="w300 fl">
                  <p className="dashboard-title__supplement">{text_list.to}</p>
                </div>
              </div>
            );
          })(enable_calendars.length > 0)}
          {enable_calendars.map( (item, index) => { return this.renderAssociationsListItem(direction, item, index, available_calendars, rooms); }, this )}
          <p><a href="#" className="link-hover-border" onClick={this.handleAddAssociation.bind(this, direction)}><i className="fa fa-plus mr5"></i>{text_list.direction}を追加</a></p>
        </div>
      </div>
    );
  }

  renderAssociationsListItem (direction, item, index, calendars, rooms) {
    let renderCalendarSelectBox = function(){
      let calendars_for_select = [{name: '選択してください', foreign_resource_id: ''}].concat(calendars);
      return (
        <span className="form-select__inner">
          <label className="form-select">
            <select className="w300" name='external_account_services[][foreign_resource_id]' defaultValue={item.foreign_resource_id}>
              {calendars_for_select.map( (calendar) => { return <option key={calendar.foreign_resource_id}  value={calendar.foreign_resource_id}>{calendar.name}</option>; } )}
            </select>
          </label>
        </span>
      );
    };

    let renderRoomSelectBox = function(){
      let defaultValue = item.account_serviceable_id;
      let rooms_for_select = [{name: '選択してください', id: ''}].concat(rooms);
      return (
        <span className="form-select__inner">
          <label className="form-select">
            <input type='hidden' name='external_account_services[][account_serviceable_type]' value='Room' />
            {(function() {
              if (rooms.length == 0) return;
              return (
                <select className="w300" name='external_account_services[][account_serviceable_id]' defaultValue={defaultValue}>
                  {rooms_for_select.map( (room) => { return <option key={room.id} value={room.id}>{SMFormatHelper.roomName(room)}</option>; } )}
                </select>
              );
            }())}
          </label>
        </span>
      );
    };

    let leftSideRenderer = null;
    let rightSideRenderer = null;
    if (direction == SMConst.GoogleCalendarDirection.Import) {
      leftSideRenderer = renderCalendarSelectBox;
      rightSideRenderer = renderRoomSelectBox;
    } else if (direction == SMConst.GoogleCalendarDirection.Export) {
      leftSideRenderer = renderRoomSelectBox;
      rightSideRenderer = renderCalendarSelectBox;
    }

    return(
      <div key={index} className="clearfix mb10" style={item._destroy ? { display: 'none' } : {}}>
        <input type='hidden' name={'external_account_services[][id]'} value={item.id || ''} />
        <input type='hidden' name={'external_account_services[][account_service_method]'} value={direction} />
        <input type='hidden' name={'external_account_services[][_destroy]'} value={item._destroy || false} />
        <div className="w320 fl">
          {leftSideRenderer()}
        </div>
        <div className="w35 pt7 fl">
          <i className="fa fa-long-arrow-right fa-lg"></i>
        </div>
        <div className="w400 fl">
          {rightSideRenderer()}
          <span className="ml10"><a href="#" className="link-hover-border" onClick={this.handleRemoveAssociation.bind(this, direction, item, index)}><i className="fa fa-times mr5"></i>削除</a> </span>
        </div>
      </div>
    );
  }
}

SMOSettingEditCalendarFragmentView.propTypes = {
  owner: PropTypes.object.isRequired,
  delegate: PropTypes.object,
};
export default SMOSettingEditCalendarFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSettingEditCalendarFragmentView.jsx